<template>
    <div class="container">
        <div class="row mat32">
            <div class="col-12 title">Wiadmości</div>
        </div>
        <div class="row mat24 flex-nowrap">
            <!-- Sidebar. -->
            <div class="side-bar none-mobile">
                <base-button-group>
                    <base-button
                        btn11
                        @click="$router.push({ name: 'panel-competition-mail-new', params: competition, alias: true })"
                    >
                        Wyślij e-mail
                    </base-button>
                    <base-button
                        v-if="canAccessSms"
                        btn11
                        @click="$router.push({ name: 'panel-competition-sms-new', params: competition, alias: true })"
                    >
                        Wyślij SMS
                    </base-button>
                </base-button-group>
            </div>
            <div v-if="competition" class="content-wrap">
                <validation-observer v-slot="{ handleSubmit }" ref="FormObserver" tag="div">
                    <panel-competition-form-box>
                        <p>Wiadomości e-mail</p>
                        <p class="mat16">
                            Wiadomość wysłana zostanie wyłącznie do uczestników, którzy zapisali się na
                            <b>{{ competition.name }}</b
                            >. Pamiętaj, że celem wysłania tej wiadomości jest komunikat dotyczący organizacji Twoich
                            zawodów (np. zmiana godziny startu lub odwołanie imprezy). Wiadomość ta nie powinna być
                            treścią marketingową a tym bardziej spamem.
                        </p>
                    </panel-competition-form-box>
                    <panel-competition-form-box class="mat16">
                        <div class="col-12 col-lg-8">
                            <validation-provider
                                v-slot="{ errors }"
                                name="name"
                                rules="required"
                                class="scroll-margin relative"
                            >
                                <panel-input-text
                                    v-model="form.name"
                                    label="Temat wiadomości"
                                    :error.sync="errors.name"
                                />
                                <span v-if="errors[0]" class="input-error-alt">Pole wymagane</span>
                            </validation-provider>
                        </div>
                        <!--
                        <div class="col-12 col-lg-3">
                            <base-button
                                class="mat24"
                                btn9
                                badge="fas fa-map"
                            >
                                Wyślij wiadomość do siebie
                            </base-button>
                        </div>
                        -->
                    </panel-competition-form-box>
                    <panel-competition-form-box class="mat16">
                        <div class="col-12 col-lg-8">
                            <validation-provider
                                v-slot="{ errors }"
                                name="information"
                                rules="required"
                                class="scroll-margin relative"
                            >
                                <panel-input-area
                                    ref="messageArea"
                                    v-model="form.information"
                                    label="Treść wiadomości"
                                    :rows="15"
                                    :error.sync="errors.information"
                                />
                                <span v-if="errors[0]" class="input-error-alt">Pole wymagane</span>
                            </validation-provider>
                        </div>
                        <div class="col-12 col-lg-3">
                            <p class="tags-title mat24">Znaczniki personalizacji</p>
                            <p class="tags-desc">Kliknij znacznik, aby wstawić go do treści:</p>
                            <ul class="tags-list">
                                <li v-for="tag in availableTags" :key="tag.key">
                                    <button type="button" class="tag-btn" @click="insertTag(tag.key)">
                                        [{{ tag.key }}]
                                    </button>
                                    <span class="tag-label">{{ tag.label }}</span>
                                </li>
                            </ul>
                        </div>
                    </panel-competition-form-box>
                    <panel-competition-form-box class="mat16">
                        <div class="w-full mab16">
                            <p class="title">Opcje wysyłki</p>
                        </div>
                        <div class="radio-wrap">
                            <div class="radio-wrap-column">
                                <label class="mab8">Wyślij do uczestników</label>
                                <panel-input-base-radio
                                    v-for="option in sendPaymentOptions"
                                    :key="option.value"
                                    v-model="form.send_payment"
                                    name="formSendPayment"
                                    :option="option"
                                />
                            </div>
                            <div class="radio-wrap-column">
                                <label class="mab8">Wyślij do uczestników z wybranej kategorii</label>
                                <panel-input-base-radio
                                    v-for="option in classificationOptions"
                                    :key="option.value"
                                    v-model="form.send_classification"
                                    name="formSendClassification"
                                    :option="option"
                                />
                            </div>
                            <!--
                            <div class="radio-wrap-column">
                                <label class="mab8">Typ</label>
                                <panel-input-base-radio
                                    v-model="form.type"
                                    name="formType"
                                    :option="{ value: 'newsletter', title: 'Newsletter' }"
                                />
                                <panel-input-base-radio
                                    v-model="form.type"
                                    name="formType"
                                    :option="{ value: 'results', title: 'Results' }"
                                />
                            </div>
                            -->
                            <div class="radio-wrap-column">
                                <p>Liczba odbiorców</p>
                                <b
                                    v-if="!loadingCount"
                                    class="recipient-count"
                                    :class="{ 'recipient-count--zero': recipientCount === 0 }"
                                    >{{ recipientCount }}</b
                                >
                                <span v-else class="recipient-count recipient-count--loading">Ładowanie...</span>
                                <p v-if="!loadingCount && recipientCount === 0" class="no-recipients-warning">
                                    Brak odbiorców spełniających wybrane kryteria. Zmień opcje wysyłki, aby wysłać
                                    wiadomość.
                                </p>
                            </div>
                        </div>
                    </panel-competition-form-box>
                    <div class="actions-wrap">
                        <base-button btn2 short :disabled="loadingCsv" @click="downloadEmailsCsv">
                            <span v-if="!loadingCsv">Pobierz listę e-maili</span>
                            <span v-else>Pobieranie...</span>
                        </base-button>
                        <base-button
                            btn1
                            short
                            :disabled="isWaiting || recipientCount === 0 || loadingCount"
                            @click="handleSubmit(submit)"
                        >
                            <span v-if="!isWaiting">Wyślij wiadomość</span>
                            <span v-else>Wysyłanie...</span>
                        </base-button>
                    </div>
                </validation-observer>

                <!-- Mailings table -->
                <div class="mailings-section mat32">
                    <p class="mailings-section__title">Wysłane wiadomości e-mail</p>
                    <div v-if="loadingMailings" class="mailings-loading">Ładowanie listy mailingów...</div>
                    <div v-else-if="mailingError" class="mailings-error">{{ mailingError }}</div>
                    <table v-else class="mailings-table">
                        <thead>
                            <tr>
                                <th>Nazwa</th>
                                <th>Typ</th>
                                <th>Status</th>
                                <th>Wysłano / Całość</th>
                                <th>Postęp</th>
                                <th>Data wysłania</th>
                                <th>Data startu</th>
                                <th>Data zakończenia</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="mailings.length === 0">
                                <td colspan="8" class="mailings-table__empty">Brak wysłanych wiadomości</td>
                            </tr>
                            <tr
                                v-for="mailing in mailings"
                                :key="mailing.id"
                                class="mailings-table__row"
                                @click="openMailingDetail(mailing.id)"
                            >
                                <td>{{ mailing.name }}</td>
                                <td>{{ mailing.type }}</td>
                                <td>
                                    <span class="status-badge" :class="`status-badge--${mailing.status}`">
                                        {{ statusLabel(mailing.status) }}
                                    </span>
                                </td>
                                <td>{{ mailing.emails_send }} / {{ mailing.emails_count }}</td>
                                <td>
                                    <div class="progress-wrap">
                                        <div class="progress-bar">
                                            <div
                                                class="progress-bar__fill"
                                                :style="{ width: mailing.progress + '%' }"
                                            />
                                        </div>
                                        <span class="progress-pct">{{ mailing.progress }}%</span>
                                    </div>
                                </td>
                                <td>{{ formatDate(mailing.sended) }}</td>
                                <td>{{ formatDate(mailing.started_at) }}</td>
                                <td>{{ formatDate(mailing.completed_at) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Mailing detail modal -->
                <modal ref="mailingModal" size="xl">
                    <template #header>
                        <span>{{ selectedMailing ? selectedMailing.name : 'Szczegóły mailingu' }}</span>
                    </template>
                    <template #body>
                        <div v-if="loadingDetail" class="modal-loading">Ładowanie szczegółów...</div>
                        <div v-else-if="selectedMailing" class="mailing-detail">
                            <div class="mailing-detail__row">
                                <span class="mailing-detail__label">Status:</span>
                                <span class="status-badge" :class="`status-badge--${selectedMailing.status}`">
                                    {{ statusLabel(selectedMailing.status) }}
                                </span>
                            </div>
                            <div class="mailing-detail__row">
                                <span class="mailing-detail__label">Typ:</span>
                                <span>{{ selectedMailing.type }}</span>
                            </div>
                            <div class="mailing-detail__row">
                                <span class="mailing-detail__label">Postęp:</span>
                                <div class="progress-wrap">
                                    <div class="progress-bar">
                                        <div
                                            class="progress-bar__fill"
                                            :style="{ width: selectedMailing.progress + '%' }"
                                        />
                                    </div>
                                    <span class="progress-pct">{{ selectedMailing.progress }}%</span>
                                </div>
                            </div>
                            <div class="mailing-detail__row">
                                <span class="mailing-detail__label">Wysłano / Całość / Niewysłane:</span>
                                <span
                                    >{{ selectedMailing.emails_send }} / {{ selectedMailing.emails_count }} /
                                    {{ selectedMailing.emails_nosend }}</span
                                >
                            </div>
                            <div class="mailing-detail__row">
                                <span class="mailing-detail__label">Data wysłania:</span>
                                <span>{{ formatTimestamp(selectedMailing.sended) }}</span>
                            </div>
                            <div class="mailing-detail__row">
                                <span class="mailing-detail__label">Data startu:</span>
                                <span>{{ formatDate(selectedMailing.started_at) }}</span>
                            </div>
                            <div class="mailing-detail__row">
                                <span class="mailing-detail__label">Data zakończenia:</span>
                                <span>{{ formatDate(selectedMailing.completed_at) }}</span>
                            </div>
                            <div
                                v-if="selectedMailing.information"
                                class="mailing-detail__row mailing-detail__row--col"
                            >
                                <span class="mailing-detail__label">Treść:</span>
                                <pre class="mailing-detail__content">{{ selectedMailing.information }}</pre>
                            </div>
                            <div
                                v-if="selectedMailing.emails_list"
                                class="mailing-detail__row mailing-detail__row--col"
                            >
                                <span class="mailing-detail__label">Lista e-maili:</span>
                                <p class="mailing-detail__emails">{{ selectedMailing.emails_list }}</p>
                            </div>
                            <div
                                v-if="selectedMailing.emails_error"
                                class="mailing-detail__row mailing-detail__row--col"
                            >
                                <span class="mailing-detail__label">Błędy:</span>
                                <p class="mailing-detail__error-list">{{ selectedMailing.emails_error }}</p>
                            </div>
                        </div>
                    </template>
                    <template #footer>
                        <div />
                        <base-button btn2 short @click="$refs.mailingModal.closeModal()">Zamknij</base-button>
                    </template>
                </modal>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import { mapGetters } from 'vuex';
    import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
    import { required } from 'vee-validate/dist/rules';

    import PanelCompetitionFormBox from '@/components/PanelCompetitionFormBox';
    import PanelInputText from '@/components/PanelInputText';
    import PanelInputArea from '@/components/PanelInputArea';
    import PanelInputBaseRadio from '@/components/PanelInputBaseRadio';
    import Modal from '@/components/Modal';

    extend('required', {
        ...required,
        message: 'required_field',
    });

    export default {
        name: 'PanelCompetitionMessagesMail',
        components: {
            ValidationObserver,
            ValidationProvider,
            PanelCompetitionFormBox,
            PanelInputText,
            PanelInputArea,
            PanelInputBaseRadio,
            Modal,
        },
        props: {
            competition: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                isWaiting: false,
                form: {
                    name: '',
                    information: '',
                    send_classification: 'all',
                    send_payment: 'all',
                    type: 'newsletter',
                },
                recipientCount: 0,
                loadingCount: false,
                loadingCsv: false,
                mailings: [],
                loadingMailings: false,
                mailingError: null,
                selectedMailing: null,
                loadingDetail: false,
                errors: {},
                availableTags: [
                    { key: 'firstname', label: 'imię' },
                    { key: 'lastname', label: 'nazwisko' },
                    { key: 'playernumber', label: 'numer startowy' },
                    { key: 'date', label: 'data startu' },
                    { key: 'time', label: 'godzina startu' },
                    { key: 'pay_link', label: 'link do płatności' },
                    { key: 'statement', label: 'link do deklaracji' },
                    { key: 'regulations', label: 'link do regulaminu' },
                    { key: 'qrCode', label: 'kod QR' },
                    { key: 'classification', label: 'kategoria' },
                ],
                sendPaymentOptions: [
                    { value: 'all', title: 'Wszystkim' },
                    { value: '1', title: 'Tylko opłaconym' },
                    { value: '0', title: 'Tylko nieopłaconym' },
                    { value: 'org', title: 'Wszystkim z Twoich imprez' },
                ],
            };
        },
        computed: {
            ...mapGetters(['user', 'classificationsBy']),
            canAccessSms() {
                return (
                    this.user?.roles?.includes('ROLE_ADMIN')
                    || this.user?.roles?.includes('ROLE_OPERATOR')
                );
            },
            classifications() {
                return this.classificationsBy(this.competition);
            },
            classificationOptions() {
                const base = [{ value: 'all', title: 'Wszystkim' }];
                if (!this.classifications || this.classifications.length === 0) {
                    return base;
                }
                const items = this.classifications.map((c) => ({
                    value: String(c.id),
                    title: c.short || c.namePl,
                }));
                return [...base, ...items];
            },
        },
        watch: {
            'form.send_classification': function () {
                this.fetchRecipientCount();
            },
            'form.send_payment': function () {
                this.fetchRecipientCount();
            },
            'form.type': function () {
                this.fetchRecipientCount();
            },
        },
        mounted() {
            this.fetchRecipientCount();
            this.fetchMailings();
        },
        methods: {
            /**
             * Fetches the recipient count based on current send options.
             */
            async fetchRecipientCount() {
                if (!this.competition) return;
                this.loadingCount = true;
                try {
                    const result = await axios({
                        method: 'get',
                        url: `/competitions/${this.competition.id}/mailings/count`,
                        params: {
                            send_classification: this.form.send_classification,
                            send_payment: this.form.send_payment,
                        },
                    });
                    this.recipientCount =
                        typeof result === 'object' ? result.recipients_count ?? result.count ?? 0 : result;
                } catch (error) {
                    console.error('fetchRecipientCount error:', error);
                    this.recipientCount = 0;
                } finally {
                    this.loadingCount = false;
                }
            },

            /**
             * Fetches the list of sent mailings for this competition.
             */
            async fetchMailings() {
                if (!this.competition) return;
                this.loadingMailings = true;
                this.mailingError = null;
                try {
                    const result = await axios({
                        method: 'get',
                        url: `/competitions/${this.competition.id}/mailings`,
                    });
                    this.mailings = Array.isArray(result) ? result : [];
                } catch (error) {
                    console.error('fetchMailings error:', error);
                    this.mailingError = 'Nie udało się pobrać listy mailingów.';
                } finally {
                    this.loadingMailings = false;
                }
            },

            /**
             * Opens the mailing detail modal and fetches full detail data.
             * @param {number} id - Mailing ID
             */
            async openMailingDetail(id) {
                this.selectedMailing = null;
                this.loadingDetail = true;
                this.$refs.mailingModal.openModal();
                try {
                    const result = await axios({
                        method: 'get',
                        url: `/mailings/${id}`,
                    });
                    this.selectedMailing = result;
                } catch (error) {
                    console.error('openMailingDetail error:', error);
                } finally {
                    this.loadingDetail = false;
                }
            },

            /**
             * Submits the mailing creation form via POST.
             */
            async submit() {
                try {
                    this.isWaiting = true;
                    await axios({
                        method: 'post',
                        url: `/competitions/${this.competition.id}/mailings`,
                        data: {
                            name: this.form.name,
                            information: this.form.information,
                            send_classification: this.form.send_classification,
                            send_payment: this.form.send_payment,
                            type: this.form.type,
                        },
                    });
                    // Reset form and refresh list
                    this.form.name = '';
                    this.form.information = '';
                    this.form.send_classification = 'all';
                    this.form.send_payment = 'all';
                    this.form.type = 'newsletter';
                    this.$refs.FormObserver.reset();
                    await this.fetchMailings();
                    this.$emit('update');
                } catch (error) {
                    console.error('submit error:', error);
                } finally {
                    this.isWaiting = false;
                }
            },

            /**
             * Downloads the email list as a CSV file.
             */
            async downloadEmailsCsv() {
                if (!this.competition) return;
                this.loadingCsv = true;
                try {
                    const response = await axios({
                        method: 'get',
                        url: `/competitions/${this.competition.id}/emails/csv`,
                        responseType: 'blob',
                    });
                    const url = window.URL.createObjectURL(new Blob([response]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `emails-${this.competition.id}.csv`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                } catch (error) {
                    console.error('downloadEmailsCsv error:', error);
                } finally {
                    this.loadingCsv = false;
                }
            },

            /**
             * Inserts a tag into the message textarea at cursor position, or appends to end.
             * @param {string} key - Tag key without brackets
             */
            insertTag(key) {
                const tag = `[${key}]`;
                const textarea = this.$refs.messageArea?.$el?.querySelector('textarea');
                if (textarea) {
                    const start = textarea.selectionStart ?? textarea.value.length;
                    const end = textarea.selectionEnd ?? textarea.value.length;
                    const current = this.form.information;
                    this.form.information = current.slice(0, start) + tag + current.slice(end);
                    this.$nextTick(() => {
                        textarea.focus();
                        const newPos = start + tag.length;
                        textarea.setSelectionRange(newPos, newPos);
                    });
                } else {
                    this.form.information += tag;
                }
            },

            /**
             * Returns a human-readable label for a mailing status.
             * @param {string} status
             * @returns {string}
             */
            statusLabel(status) {
                const map = {
                    pending: 'Oczekuje',
                    completed: 'Zakończony',
                    in_progress: 'W toku',
                    failed: 'Błąd',
                };
                return map[status] ?? status;
            },

            /**
             * Formats a date string for display (YYYY-MM-DD HH:MM).
             * @param {string|null} dateStr
             * @returns {string}
             */
            formatDate(dateStr) {
                if (!dateStr) return '—';
                return dateStr.replace('T', ' ').slice(0, 16);
            },

            /**
             * Formats a Unix timestamp (seconds) for display (YYYY-MM-DD HH:MM).
             * @param {number|string|null} timestamp
             * @returns {string}
             */
            formatTimestamp(timestamp) {
                if (timestamp == null || timestamp === '') return '—';
                const date = new Date(Number(timestamp) * 1000);
                if (Number.isNaN(date.getTime())) return '—';
                const pad = (n) => String(n).padStart(2, '0');
                return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(
                    date.getHours()
                )}:${pad(date.getMinutes())}`;
            },
        },
    };
</script>

<style scoped>
    .title {
        font-family: 'Bariol Bold';
        font-size: 18px;
    }

    .side-bar {
        width: 165px;
    }

    .w-full {
        width: 100%;
    }

    .input-error-alt {
        display: block;
        color: var(--color-pinky-red, red);
        font-size: 12px;
        margin-top: 4px;
    }

    .radio-wrap {
        width: 100%;
        display: flex;
        flex-wrap: nowrap;
        gap: 16px;
    }

    .radio-wrap label {
        display: block;
    }

    .radio-wrap-column {
        flex: 1 1 0;
        min-width: 0;
        width: 33.333%;
    }

    .recipient-count {
        font-family: 'Bariol Bold';
        font-size: 18px;
    }

    .recipient-count--loading {
        font-size: 14px;
        color: var(--color-bluish-grey);
        font-weight: normal;
    }

    /* .recipient-count--zero {
        color: var(--color-pinky-red);
    } */

    .no-recipients-warning {
        margin-top: 6px;
        font-size: 12px;
        /* color: var(--color-pinky-red); */
        /* background: var(--color-pinky-red-10); */
        color: #455a64;
        background: #fff1cc;
        border-radius: 4px;
        padding: 6px 10px;
        display: block;
    }

    .actions-wrap {
        display: flex;
        justify-content: flex-end;
        gap: 8px;
        padding: 24px 0;
    }

    /* Tags panel */
    .tags-title {
        font-family: 'Bariol Bold';
        font-size: 14px;
    }

    .tags-desc {
        font-size: 12px;
        /* color: var(--color-bluish-grey); */
        margin-top: 4px;
        margin-bottom: 8px;
    }

    .tags-list {
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .tags-list li {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .tag-btn {
        background: var(--color-pale-grey);
        border: 1px solid var(--color-silver);
        border-radius: 4px;
        padding: 2px 8px;
        font-size: 12px;
        color: var(--color-slate);
        cursor: pointer;
        font-family: monospace;
        transition: background 0.15s, border-color 0.15s;
        flex-shrink: 0;
    }

    .tag-btn:hover {
        background: var(--color-silver);
        border-color: var(--color-cool-grey);
    }

    .tag-label {
        font-size: 12px;
        /* color: var(--color-bluish-grey); */
    }

    /* Mailings section */
    .mailings-section {
        border-top: 1px solid var(--color-silver);
        padding-top: 24px;
    }

    .mailings-section__title {
        font-family: 'Bariol Bold';
        font-size: 18px;
        margin-bottom: 16px;
    }

    .mailings-loading {
        padding: 16px;
        font-size: 14px;
        color: var(--color-bluish-grey);
    }

    .mailings-error {
        padding: 16px;
        font-size: 14px;
        color: var(--color-pinky-red);
    }

    /* Mailings table */
    .mailings-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 13px;
    }

    .mailings-table th {
        background: var(--color-pale-grey);
        color: var(--color-slate-two);
        padding: 10px 12px;
        text-align: left;
        font-family: 'Bariol Bold';
        font-weight: normal;
        border-bottom: 2px solid var(--color-silver);
        white-space: nowrap;
    }

    .mailings-table td {
        padding: 10px 12px;
        border-bottom: 1px solid var(--color-light-grey);
        vertical-align: middle;
        color: var(--color-greyish-brown);
    }

    .mailings-table__row {
        cursor: pointer;
        transition: background 0.15s;
        background: var(--color-light-grey);
    }

    .mailings-table__row:hover td {
        background: var(--color-gray-hover);
    }

    .mailings-table__empty {
        text-align: center;
        color: var(--color-cool-grey);
        padding: 24px;
    }

    /* Status badge */
    .status-badge {
        display: inline-block;
        padding: 2px 8px;
        border-radius: 10px;
        font-size: 11px;
        font-weight: bold;
        text-transform: uppercase;
        letter-spacing: 0.04em;
    }

    .status-badge--pending {
        background: rgba(176, 190, 197, 0.25);
        color: var(--color-slate-two);
    }

    .status-badge--in_progress {
        background: var(--color-light-sage-40);
        color: var(--color-charcoal-grey);
    }

    .status-badge--completed {
        background: rgba(80, 174, 85, 0.15);
        color: var(--color-dark-pastel-green);
    }

    .status-badge--failed {
        background: var(--color-pinky-red-10);
        color: var(--color-pinky-red);
    }

    /* Progress bar */
    .progress-wrap {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .progress-bar {
        flex: 1;
        min-width: 60px;
        height: 6px;
        background: var(--color-silver);
        border-radius: 3px;
        overflow: hidden;
    }

    .progress-bar__fill {
        height: 100%;
        background: var(--color-dark-pastel-green);
        border-radius: 3px;
        transition: width 0.3s;
    }

    .progress-pct {
        font-size: 11px;
        color: var(--color-bluish-grey);
        white-space: nowrap;
    }

    /* Modal detail */
    .modal-loading {
        padding: 24px;
        color: var(--color-bluish-grey);
    }

    .mailing-detail {
        padding: 24px;
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .mailing-detail__row {
        display: flex;
        align-items: center;
        gap: 12px;
    }

    .mailing-detail__row--col {
        flex-direction: column;
        align-items: flex-start;
        gap: 6px;
    }

    .mailing-detail__label {
        font-family: 'Bariol Bold';
        color: var(--color-slate-two);
        min-width: 120px;
        flex-shrink: 0;
    }

    .mailing-detail__content {
        background: var(--color-pale-grey);
        border: 1px solid var(--color-silver);
        border-radius: 4px;
        padding: 12px;
        font-size: 13px;
        white-space: pre-wrap;
        word-break: break-word;
        /* width: 100%; */
        max-height: 200px;
        overflow-y: auto;
        margin: 0;
    }

    .mailing-detail__emails,
    .mailing-detail__error-list {
        font-size: 12px;
        color: var(--color-bluish-grey);
        background: var(--color-light-grey);
        border-radius: 4px;
        padding: 8px 12px;
        word-break: break-all;
        /* width: 100%; */
        margin: 0;
    }

    .mailing-detail__error-list {
        color: var(--color-pinky-red);
    }

    @media (min-width: 992px) {
        .content-wrap {
            margin-left: 30px;
        }
    }

    @media (max-width: 991px) {
        .radio-wrap {
            flex-wrap: wrap;
        }

        .radio-wrap-column {
            flex: 1 1 100%;
            width: 100%;
        }
    }
</style>
